import './App.css';
import { Routes, Route } from 'react-router-dom'
import Sign from './components/Sign'
import logo from './images/logo.svg'

function App() {
    return<div className="App">
        <header className="header">
            <img src={logo}></img>
            <h1>Заявление на регистрацию ККТ</h1>
        </header>
        <main className='main'>
            <Routes>
                {/* <Route exact path='/' element={<Sign/>}/> */}
                <Route path='/:id' element={<Sign/>}/>
                {/* <Route>
                    <Page404/>
                </Route> */}
            </Routes>
        </main>
    </div> 
}

export default App;
